/**

 Registriert SignalEvents:
 =========================

 maploaded       (map:ym.map.CMap, event:Object)
 mapstartmove    (map:ym.map.CMap, event:Object)
 mapendmove      (map:ym.map.CMap, event:Object)
 mapendzoom      (map:ym.map.CMap, event:Object)
 mapchangestyles (map:ym.map.CMap, event:Object)
 mapmouseout     (map:ym.map.CMap, event:Object)
 mapmouseover    (map:ym.map.CMap, event:Object)
 mapmousedown    (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 mapmouseup      (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 mapresize       (map:ym.map.CMap, event:Object)

 */

function CMapSignals(/** ym.map.CMap */mapObj, /** ym.event.CEventEmitter */signalsObject) {
    this.signalsObject = signalsObject;

    var self = this,
        events = [
            "onload",
            "onstartmove",
            "onendmove",
            "onendzoom",
            "onchangemapstyle",
            "onclick",
            "onmouseover",
            "onmouseout",
            "onmousedown",
            "onmouseup",
            "onresize"
        ];

    this.map = map;

    function _addListener(eventName) {
        return function () {
            self['_' + eventName].apply(self, Array.prototype.slice.call(arguments, 0));
        }
    }

    for (var i = 0, l = events.length; i < l; i++) {
        this.map.addListener(events[i], _addListener(events[i]));
    }
}

CMapSignals.prototype = {
        signalsObject: null,

        constructor: CMapSignals,

        /** map events **/
        _onload: function (event) {
            this.signalsObject.emit("maploaded", this.map, event);
        },

        _onstartmove: function (event) {
            this.signalsObject.emit("mapstartmove", this.map, event);
        },

        _onendmove: function (event) {
            this.signalsObject.emit("mapendmove", this.map, event);
        },

        _onendzoom: function (event) {
            this.signalsObject.emit("mapendzoom", this.map, event);
        },

        _onchangemapstyle: function (event) {
            this.signalsObject.emit("mapchangestyle", this.map, event);
        },

        _onclick: function (event) {
            this.signalsObject.emit("mapclick", this.map, event);
        },

        _onmouseover: function (event) {
            this.signalsObject.emit("mapmouseover", this.map, event);
        },

        _onmouseout: function (event) {
            this.signalsObject.emit("mapmouseout", this.map, event);
        },

        _onmousedown: function (pos) {
            this.signalsObject.emit("mapmousedown", this.map, pos.GeoPosition, pos.PixelPosition);
        },

        _onmouseup: function (pos) {
            this.signalsObject.emit("mapmouseup", this.map, pos.GeoPosition, pos.PixelPosition);
        },

        _onresize: function (event) {
            this.signalsObject.emit("mapresize", this.map, event);
        }
        /** map events **/
    };
